<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container lg">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">プロフィール画像の変更</span>
        </div>
        <div class="popup-content">
          <p class="txt mb8">プロフィール画像を下記よりアップしてください。</p>
          <p class="txt-sup mb32">アップロード可能な画像のファイルサイズは最大10Mまで、jpg、pngフォーマットの画像ファイルのみです。</p>
          <div class="popup-content-inner">
            <p class="hdg04 mb20">画像のアップロード</p>

            <div class="formparts function file">
              <input type="file" id="file_upload" @change="file.setProfileImage">
              <span class="fake-txt">
                <template v-if="file.imagePath">{{ file.imagePath }}</template>
                <template v-else>ファイルを選択</template>
              </span>
              <label for="file_upload" role="button"></label>
            </div>

            <div v-if="file.loading" class="mt32 no-image" style="width: 76px; height: 76px; margin: 0 auto;"><FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" /></div>
            <div v-else-if="file.getImage" class="preview mt32" :style="{backgroundImage : 'url(' + file.getImage + ')'}"></div>
            <div v-else class="preview mt32 no-image">{{profile.name.slice(0, 1)}}</div>
            
          </div>
          <div class="button mt32" :class="{' is-inactive': !file.isSubmitButtonClickable}">
            <button class="btn" type="submit" @click="file.saveProfileImage">設定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ProfileChangeImage } from '@/logic/profile/ProfileChangeImage'

export default defineComponent({

  setup (props, context) {
    return { ...ProfileChangeImage(context) }
  }
})
</script>

<style lang="scss" scoped>
.preview {
  width: 220px;
  height: 220px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  &.no-image {
    background-color: $color-no-image;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13.6rem;
    font-weight: bold;
    color: $color-hdg;
  }
}
.popup-content {
  .button .btn {
    width: 230px;
    margin: 0 auto;
  }
  &-inner {
    background-color: #F9F8F6;
    border-radius: 8px;
    border: 1px solid $color-line;
    padding: 40px;
    .formparts.file {
      position: relative;
      .fake-txt {
        width: 100%;
      }
      label {
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
